import { Controller } from "@hotwired/stimulus"
import Cleave from 'cleave.js';

// Connects to data-controller="promo-discount"
export default class extends Controller {
  static targets = [
    "value"
  ]
  connect() {
    const inputElement = this.valueTarget;
    // Store the current value and convert decimal point to comma if needed
    const currentValue = inputElement.value;
    const formattedValue = currentValue ? currentValue.replace('.', ',') : '';
    
    new Cleave(inputElement, {
      numeral: true,
      numeralDecimalMark: ',',
      delimiter: '.'
    });
    
    // Set the formatted value after Cleave initialization
    if (formattedValue) {
      inputElement.value = formattedValue;
    }
  }
}
